import axios, {AxiosError, AxiosResponse} from "axios";

export const eatalianoAxios = axios.create({
    baseURL: process.env.BACKEND_API_BASE_URL,
    withCredentials: true,
});

eatalianoAxios.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => {
        return Promise.reject(error);
    }
);

